const message = {
  select: "select",
  team: "team",
  submit: "submit",
  collaborator: "collaborator",
  create: "create",
  site: "site",
  categories: "categories",
  download: "download",
  totalHours: "total hours",
  received_polyvalence: "received polyvalence",
  polyvalence: "polyvalence",
  total: "total",
  edit: "edit",
  remove: "remove",
  date: "date",
  restore: "restore",
  areYouSure: "Are you sure?",
  restoreProcess: "you are about to restore a deleted process",
  yes_i_understand: "Yes, I understand",
  cancel: "Cancel",
  showDeletedProcesses: "show deleted processes",
  update: "update",
  restore_description: "You are about to restore a deleted process",
  deleteDescription: "You are about to delete a process",
  requiredFieldsAreMissing: "required fields are missing",
  errNetwork: "service unavailable",
  err400: "invalid data",
  err403: "forbidden",
  err404: "not found page",
  err409: "data already exist ",
  err500: "service error",
  err501: "server not available",
  "Site not Found": "site not Found",
  pending_save: "Pending to save",
  hours_pending_save_description: "You are about to lose the declared hours",
  save: "save",
  ignore: "Ignore",
  destroyed_hours: "destroyed hours",
  recovered_hours: "recovered hours",
  saved_hours: "saved hours",
  recovered_process: "recovered process",
  delete_category_description: "You are about to delete a category",
  delete_site_description: "You are about to delete a site",
  deleted_category: "the category is deleted",
  deleted_site: "the site is deleted",
  required_field: "required field",
  required_field_category_description: "the description field is required",
  required_field_category_name: "the name field is required",
  required_field_fedid_site_code: "the fedid site code is required",
  required_field_site_name: "the site name is required",
  required_field_site_code: "the site code is required",
  created_category: "the category is created",
  created_site: "the site is created",
  "Activity duration exceding 9 Hours.": "Activity duration exceding 9 Hours",
  change_your_site: "change your site",
  change_your_team: "change your team",
  change_your_email: "change your email",
  have_api_planning: "have api planning",
  table_is_empty: "the table is empty",
  add_to_drive: "add to my google drive",
  configuration: "configuration",
  economic: "economic",
  explotation: "explotation",
  account: "account",
  hda: "hda",
  "Total Hours of whole activities is more than 9h.": "total Hours of whole activities is more than 9h.",
  "bad request": "bad request",
  "page not found": "page not found",
  select_date: "select date",
  select_week: "select week",
  select_team: "select team",
  select_collaborator: "select collaborator",
  date_from: "from...",
  date_to: "to...",
  more_options: "more options",
  close_dialog: "close dialog",
  where_you_have_worked: "where you have worked",
  when_you_have_worked: "when you have worked",
  the_week_what_do_you_search: "the week what do you search",
  the_team_what_do_you_search: "the team what do you search",
  the_collaborator_what_do_you_search: "the collaborator what do you search",
  site_name: "site name",
  site_code: "site code",
  fedid_site_code_openid: "fedid site code openId",
  fedid_site_code: "fedid site code",
  site_code_planning: "site code center planning",
  categoryName: "category name",
  category_description: "category description",
  user_title: "user name",
  total_hours_title: "total",
  total_hours_provider_title: "total planning",
  difference_hours_title: "difference",
  hours_in_team_title: "hours in team",
  given_polyvalence_title: "given polyvalence",
  received_polyvalence_title: "received polyvalence",
  process: "process",
  polyvalence_team: "polyvalence team",
  hours: "hours",
  date_title: "date",
  name: "name",
  planning_code: "planning code center",
  fedid_code: "fedid code center",
  description: "description",
  reset_form: "reset form",
  provider_api: "is connected with planning",
  no: "no",
  yes: "yes",
  your_email_does_not_exist_in_the_app: "your profile does not existe in the app",
  we_can_create_a_fictitious_profile_in_a_fictitious_center:
    "you can create a foctitious profile in a fictitious center",
  you_are_about_to_create_a_fictitious_profile_in_a_fictitious_center:
    "you are about to create a fictitious profile in a fictitious center",
  the_value_should_between_0_and_9: "the quantity of hours should between 0h and 9h",
  excel: "excel",
  no_content: "there isn't content",
  "logistic process": "logistic process",
  total_hours: "total hours",
  planning: "planning",
  logistic_process: "process",
  dates_error: "dates error",
  date_from_is_later_than_date_to: "the initial date is later than end date",
  username: "username",
  dni: "id",
  uuid: "uuid",
  sap_number: "sap number",
  email: "email",
  select_site: "select a site",
  new_collaborator: "new collaborator",
  all_fields_are_required: "all fields are required",
  field_are_required: "field are required",
  sap_structure_number: "sap structure number",
  delete_team_description: "You are about to delete a team",
  "deleted/notDeleted": "deleted or not deleted",
  total_hda: "total hda",
  total_team: "total team",
  ask_support: "ticket soporte it",
  manual: "manually",
  is_manual_user: "is a manually user",
  sites: "sites",
  sites_where_has_access: "sites where has access",
  select_multi_vada: "select multi vada",
  change_site: "change to an other site",
  total_days: "total days",
  dont_forget_edit_form: "Do not forget to select sites",
  no_options: "No options avaiable",
  selected: "selected",
  clean_selection: "clean selection",
  process_form_name_placeholder: "Name",
  process_form_description_placeholder: "Description",
  process_form_minutes_placeholder: "Min",
  cancel_registration: "Cancel registration",
  loading_options: "Loading options...",
  registering: "Registering...",
  register_entry: "Register entry",
  field_name_example: "Eg: user_age",
  field_label_example: "Eg: User age",
  field_help_text_placeholder: "Helper text...",
  field_select_placeholder_example: "Eg: Select an option...",
  url_placeholder: "https://...",
  category_name_example: "Eg: VIP visit",
  category_description_short_placeholder: "Short category description...",
  search_field_name_or_label: "Search field by name or label...",
  write_here: "Write here...",
  continue: "Continue",
  custom_color: "Custom color",
  select_a_color: "Select a color",
  email_placeholder_default: "example@email.com",
  field_type_text: "Text",
  field_type_number: "Number",
  field_type_select: "Select",
  field_type_checkbox: "Checkbox",
  field_type_calendar: "Date",

  site_form: {
    name: "Site Name",
    name_placeholder: "Name",
    code: "Site code",
    code_placeholder: "Site code",
    code_fedid: "Site FEDID code",
    code_fedid_placeholder: "FEDID code",
    planning: "Connected to planning",
  },
  category_form: {
    name: "Category name",
    name_placeholder: "Name",
    desc: "Category description",
    desc_placeholder: "Description",
  },
  collaborator_form: {
    name: "Full name",
    name_placeholder: "Name",
    username: "Profile",
    username_placeholder: "Profile",
    dni: "DNI",
    dni_placeholder: "DNI",
    uuid: "UUID",
    uuid_placeholder: "Uuid",
    sap: "SAP number",
    sap_placeholder: "SAP number",
    email: "Email",
    email_placeholder: "Email",
    sites: "Select VADA sites",
    manual: "Manual user",
  },
  team_form: {
    name: "Name",
    name_placeholder: "Name",
    desc: "Description",
    des_placeholder: "Description",
    sap: "SAP number",
    sap_placeholder: "SAP number",
    uuid: "Uuid",
    uuid_placeholder: "Uuid",
  },

  add: "Add",
  delete_collaborator_description: "You are deleting a collaborator",
  deleted_collaborator: "Collaborator deleted",
  search_by_mail: "Search collaborator by mail",
  user_not_found_or_error: "User not found or error",
  usurpation_completed: "Usurpation completed",
  usurpate: "Usurpate",
  search: "Search",
  removed_team: "Team removed",
  updated_collaborator: "Updated collaborator",
  you_are_about_delete_a_user: "You are about to delete a user",
  you_are_about_to_delete_a_team:
    "You are about to delete a team. Please check if the team has collaborators inside — if so, do not delete it as you will not be able to access them afterwards",
  fields: "Fields",
  visitorsSites: "Visitor sites",
  visitorsTeams: "Visitor teams",
  leaders: "Leaders",
  visitorsCategories: "Visitor categories",
  reserved_space: "Reserved space",
  loading: "Loading",
  no_data: "No data",
  success: "Success",
  error: "Error",
  not_found: "Not found",
  visitor_data_loaded: "Visitor details loaded successfully",
  visitor_not_found_key_value: "No previous records found for this value",
  search_error: "Error searching for visitor details",
  ok: "OK",
  unknown: "Unknown",
  register_error: "Registration error",
  error_500: "Unexpected server error",
  error_deleting: "Error deleting",
  process_form_max_hours_placeholder: "Max hours",
  language_spanish: "Spanish",
  language_english: "English",
  language_french: "French",
  edit_field: "Edit field",
  new_field: "New field",
  edit_category: "Edit category",
  config_fields_subtitle_edit: "Modify the existing field data.",
  config_fields_subtitle_create: "Define the properties and configuration of the new input.",
  config_categories_subtitle: "Define the name, color and fields that will compose this category form.",
  validation_error: "Validation error",
  updated_successfully: "Updated successfully",
  created_successfully: "Created successfully",
  form_error_loading_data: "An error occurred while loading the data.",
  form_error_saving_retry: "An error occurred while saving. Please try again.",
  config_error_loading_available_sites: "Could not load available sites.",
  config_error_loading_available_teams: "Could not load available teams.",
  config_error_loading_sites_list: "Could not load sites list.",
  config_error_loading_teams_list: "Could not load teams list.",
  config_error_loading_list: "Could not load list.",
  config_error_loading_categories_list: "Could not load categories list.",
  config_error_loading_fields_list: "Could not load fields list.",
  config_error_saving_site: "Error saving site",
  config_error_unexpected_server: "Unexpected error while communicating with server.",
  config_error_saving_team: "Error saving team",
  config_error_saving_leader: "Error saving leader",
  config_error_saving_category: "Error saving category",
  config_error_deleting_site: "Error deleting site",
  config_error_deleting_team: "Error deleting team",
  config_error_deleting_leader: "Error deleting leader",
  config_error_deleting_category: "Error deleting category",
  config_error_deleting_field: "Error deleting field",
  config_error_loading_site_teams: "Could not load teams for this site.",
  config_error_loading_teams: "Error loading teams",
  config_error_loading_form_data: "Error loading form data",
  config_error_saving_form: "Error saving form",
  visitors_error_loading_history: "Could not load visitors history.",
  visitors_error_loading_categories: "Could not load categories.",
  visitors_error_category_data_not_found: "No data found for this category.",
  visitors_error_loading_form_config: "Could not load form configuration.",
  visitors_registered_successfully: "Visitor was registered successfully.",
  visitors_error_registering: "Could not register visitor. Please try again.",
  exit_registered: "Exit registered",
  visitors_exit_registered_successfully: "Visitor exit was registered successfully.",
  visitors_error_registering_exit: "Could not register visitor exit.",
  visitors_invalid_date_range: "The end date must be equal to or later than the start date.",
  visitors_missing_center_code: "Could not resolve center code to filter visitors history.",
  visitor_default_name: "Visitor",
  visitor_without_name: "Visitor without name",
  without_number: "Without number",
  option_without_name: "Unnamed option",
  field_without_valid_source_url: "Field {field} has an invalid sourceUrl.",
  source_url: "Source URL",
  no_data_available: "No data available",
  active: "active",
  add_field: "Add field",
  add_new_field: "Add new field",
  all: "All",
  all_categories: "All categories",
  back: "Back",
  badge: "Badge",
  branch: "Branch",
  careful: "Careful",
  category: "Category",
  center: "Center",
  clear_search: "Clear search",
  close: "Close",
  "collaboratormail@decathlon.com": "collaborator{'@'}decathlon.com",
  color: "Color",
  complete_required_info: "Complete required info",
  created_collaborator: "Collaborator created",
  created_leader: "Leader created",
  created_team: "Team created",
  dangerous: "Dangerous",
  dangerous_process: "Dangerous process",
  delete_field_description: "You are about to delete a field",
  delete_leader_description: "You are about to delete a leader",
  deleted: "deleted",
  deleted_field: "Field deleted",
  deleted_leader: "Leader deleted",
  deleted_team: "Team deleted",
  "email_without_@decathlon.com": "Email must include {'@'}decathlon.com",
  emails: "Emails",
  error_creating_process: "Error creating process",
  error_updating: "Error updating",
  exit_visitor: "Exit visitor",
  field_name: "Field name",
  fields_not_found: "Fields not found",
  fill_required_fields: "Fill required fields",
  from: "From",
  given_polyvalence: "Given polyvalence",
  hour_in: "Hour in",
  hour_out: "Hour out",
  hour_out_is_smaller_than_hour_in: "Hour out is smaller than hour in",
  impersonating: "Impersonating",
  invalid_email: "Invalid email",
  is_required: "is required",
  label: "Label",
  liberate: "Liberate",
  link_href: "Link",
  logout: "Logout",
  mail: "Mail",
  max_hours_inversion: "Max hours cannot be less than min hours",
  more_info: "More info",
  new: "New",
  new_category: "New category",
  new_visitor: "New visitor",
  no_categories_available: "No categories available",
  no_custom_fields_added: "No custom fields added",
  no_more_visitors: "No more visitors",
  no_visitors: "No visitors",
  optional: "Optional",
  placeholder: "Placeholder",
  press_enter_to_add_email: "Press Enter to add email",
  preview_category_form: "Category form preview",
  process_created: "Process created",
  process_name: "Process name",
  process_updated: "Process updated",
  remove_visitor_description: "You are about to register visitor exit",
  required: "Required",
  required_abreviation: "Req.",
  required_field_error: "Required field",
  required_filed_category_description: "Category description is required",
  required_filed_category_name: "Category name is required",
  reset_filters: "Reset filters",
  select_category: "Select category",
  select_fields_preview: "Select fields preview",
  select_inputs: "Select inputs",
  select_option: "Select an option",
  service: "Service",
  subtype: "Subtype",
  team_deleted: "Team deleted",
  teams: "Teams",
  to: "To",
  type: "Type",
  type_of_select: "Select type",
  uid: "UID",
  updated_category: "Category updated",
  updated_leader: "Leader updated",
  updated_site: "Site updated",
  updated_team: "Team updated",
  user: "User",
  validation: "Validation",
  view: "View",
  visitor_data: "Data",
  visitors_evacuation_download: "Evacuation",
  visitors_evacuation_download_error: "Could not download the evacuation report",
  visitors: "Visitors",
  you_are_about_create_a_planning: "You are about to create planning",
  search_by_name_or_badge: "Search by name or badge...",
  visitor_site_form: {
    emails: "Emails",
    emails_placeholder: "Type email and press Enter",
  },

  bookings: {
    home: {
      title: "Loans Management",
      description: "Add equipment to your cart from any category and choose dates when submitting the booking",
      subtitleShort: "Check loan alerts and browse the catalog by type, category or search",
      browse: "Browse catalog",
      cart: "My cart",
      myReservations: "My reservations",
      adminPanel: "Admin panel",
      searchTitle: "Search equipment",
      searchDescription: "Find products across the entire catalog, regardless of type or category",
      browseByType: "Browse by type",
      browseByTypeHint: "Optional: explore the catalog and combine products from different categories in one cart",
      alerts: {
        title: "Your alerts",
        empty: "You have no loans requiring action right now",
        viewReservation: "View booking",
        viewReservations: "My reservations",
        localCartExpired: "Your cart has expired — clear it or submit again",
        overdueReturn: "Return overdue — past the due date",
        returnToday: "Return due today",
        returnTomorrow: "Return due tomorrow",
        deliveryOverdue: "Pickup pending — the loan start date has passed",
        deliveryToday: "Pickup scheduled for today",
        deliveryTomorrow: "Pickup scheduled for tomorrow",
        cartExpiringSoon: "Booking not submitted — expiring soon",
        cartExpired: "Unsubmitted booking — expired",
      },
      recentProducts: {
        title: "Borrow again",
        subtitle: "Items you have reserved recently",
      },
      explorer: {
        title: "Browse catalog",
        subtitle: "Filter by type and category or search products across the catalog",
        searchPlaceholder: "Search by name, reference...",
        startHint: "Type or choose a filter to see products here",
        selectTypeHint: "Choose a material type",
        selectCategoryHint: "Choose a category",
        selectSubCategoryHint: "Choose a subcategory",
        productsHint: "Products available in this subcategory",
        searchResultsHint: "Catalog search results",
        type: "Type",
        category: "Category",
        subCategory: "Subcategory",
        allTypes: "All",
        viewProducts: "View products",
        openCatalog: "Open catalog",
        clearFilters: "Clear filters",
        noCategories: "No categories available for this type",
        noSubCategories: "No subcategories in this category",
      },
      calendar: {
        title: "Loan calendar",
        instruction: "Select dates",
        previousMonth: "Previous month",
        nextMonth: "Next month",
        legendRange: "Loan period",
        legendPickup: "Pickup",
        legendReturn: "Return",
        bookedDay: "Loan day: {date}",
        pickupDay: "Pickup: {date}",
        returnDay: "Return: {date}",
        singleDay: "Pickup and return: {date}",
      },
    },
    catalog: {
      title: "Catalog",
      types: "Booking types",
      categories: "Categories",
      subCategories: "Subcategories",
      products: "Products",
      availableUnits: "0 units available | 1 unit available | {count} units available",
      addToCart: "Add to cart",
      viewProduct: "View product",
      addedToCart: "Product added to cart. You can keep browsing the catalog.",
      quantity: "Units",
      increaseQuantity: "Increase units",
      decreaseQuantity: "Decrease units",
      noUnits: "No units available",
      inCart: "0 in cart | 1 in cart | {count} in cart",
      unitsAvailable: "{available} / {total} available",
      maxUnitsPerReservation: "Max. {count} per reservation",
      maxInCart: "You already have the maximum available in your cart",
      browseAndAdd: "Select quantities and add them to your cart. Dates are chosen when submitting the booking.",
      availabilityOnCheckout: "Final availability will be checked when you select dates in the cart.",
      searchResults: "Search results",
      searchFilters: {
        title: "Search filters",
        subtitle: "Combine text, type, category and subcategory to find items across the catalog",
        availableOnly: "Only products with available units",
        allCategories: "All categories",
        allSubCategories: "All subcategories",
        resultsCount: "0 products found | 1 product found | {count} products found",
      },
      selectDates: "Select loan dates",
      noTypes: "No booking types available",
      noCategories: "No categories available",
      emptyCategoriesHint: "This booking type has no categories yet. Go back home and try another type.",
      noSubCategories: "No subcategories available",
      noProducts: "No products available",
      available: "available",
      default: "Default",
      allProducts: "All products",
      subCategoriesHint: "Choose a subcategory or browse all products in this category",
      searchProducts: "Search products...",
      emptyProducts: "No products in inventory",
      emptyTypes: "No booking types created",
      errorLoad: "Could not load catalog",
      category: "Category",
      subCategory: "Subcategory",
      type: "Type",
      referenceCode: "Reference code",
      maxDays: "Max. reservation days",
      maxUnits: "Max. units per reservation",
      filters: {
        search: "Search...",
        availability: "Availability",
        status: "Status",
        clear: "Clear filters",
      },
    },
    productDetail: {
      description: "Description",
      specifications: "Product information",
      availability: "Current availability",
    },
    images: {
      image: "Image",
      file: "Image file",
      manage: "Images",
      upload: "Upload image",
      altText: "Alternative text",
      markPrimary: "Set as primary image",
      primary: "Primary",
      setPrimary: "Set primary",
      regenerate: "Regenerate",
      empty: "No images",
      noAlt: "No alt text",
    },
    cart: {
      title: "My cart",
      subtitle: "Review selected equipment and choose dates to submit the booking",
      empty: "Your cart is empty",
      browse: "Browse catalog",
      period: "Booking period",
      selectDates: "Loan dates",
      selectDatesHint: "Choose the period when you will need the equipment",
      confirmRequiresDates: "Select dates before submitting the booking request",
      datesLockedByReservation: "Dates cannot be changed while the booking is being processed",
      expired: "Cart expired",
      expiresAt: "Expires at {time}",
      confirm: "Submit booking request",
      cancel: "Cancel cart",
      clear: "Clear",
      increase: "Increase quantity",
      decrease: "Decrease quantity",
      remove: "Remove item",
      confirmTitle: "Confirm booking?",
      confirmText: "Once confirmed, units will be assigned.",
      continueBrowsing: "Continue browsing",
      itemsTitle: "Selected equipment",
      checkout: "Submit booking",
      summary: "Summary",
      itemsCount: "No products | 1 product | {count} products",
      acceptLegal: "Accept the legal conditions",
      acceptLegalHere: "here",
      acceptedLegal: "Legal conditions accepted",
      LegalConditionsTitle: "Terms and Conditions",
      LegalConditionsSubtitle: "You must read to the end to be able to accept.",
      acceptLegalAction: "Accept conditions",
      scrollToAccept: "Scroll to accept",
      viewLegal: "View",
      close: "Close",
    },
    notifications: {
      addedToCart: "Added to cart",
      addedToCartDetail: "{name} × {count}",
      cartLimitReached: "You cannot add more units",
      cartLimitReachedDetail: "Maximum allowed: {max}",
      cartPartialAdd: "Only some units were added due to stock limits",
      removedFromCart: "Removed from cart",
      cartCleared: "Cart cleared",
      cartCancelled: "Pending booking cancelled",
      datesApplied: "Loan dates updated",
      reservationSubmitted: "Booking request submitted",
      reservationPending: "Booking created. Confirm to finish.",
      reservationConfirmed: "Booking confirmed",
      reservationCancelled: "Booking cancelled",
    },
    confirmation: {
      title: "Request submitted!",
      subtitle: "Your booking request has been registered successfully",
      pendingAdminDelivery:
        "An administrator will confirm equipment delivery. Return will also be verified by the team when the loan ends.",
      reservationId: "Reservation ID",
      reservationSummary: "Reservation summary",
      period: "Loan period",
      viewMyReservations: "View my reservations",
    },
    myReservations: {
      title: "My reservations",
      subtitle: "Browse, filter and manage all your equipment bookings",
      empty: "You have no reservations",
      emptyFiltered: "No reservations match your filters",
      emptyFilteredHint: "Try changing the status, period or search terms",
      itemsCount: "No items | 1 item | {count} items",
      detail: "Reservation detail",
      cancel: "Cancel reservation",
      cancelConfirm: "Are you sure you want to cancel this reservation?",
      download: "Download document",
      table: {
        id: "Reference",
        createdAt: "Requested",
      },
      filters: {
        title: "Filter reservations",
        subtitle: "Refine the list by status, dates or reference",
        searchPlaceholder: "Search by center, collaborator or ID...",
        stateGroup: "Status",
        period: "Period",
        sort: "Sort by",
        expand: "Show filters",
        collapse: "Hide filters",
        removeTag: "Remove filter",
        resultCount: "No reservations | 1 reservation found | {count} reservations found",
        showingRange: "Showing {from}-{to} of {total}",
        sortNewest: "Newest first",
        sortOldest: "Oldest first",
        sortFromDateAsc: "Start date (ascending)",
        sortFromDateDesc: "Start date (descending)",
        groups: {
          all: "All",
          active: "Active",
          inProgress: "In progress",
          completed: "Completed",
          cancelled: "Cancelled",
        },
        periods: {
          all: "Any date",
          upcoming: "Upcoming",
          thisMonth: "This month",
          last3Months: "Last 3 months",
          custom: "Custom range",
        },
        tags: {
          search: "Search: {query}",
          customRange: "{from} → {to}",
        },
      },
    },
    checkout: {
      title: "Booking confirmation",
      success: "Booking created successfully",
      viewDetail: "View detail",
      pending: "Pending confirmation",
      confirm: "Confirm",
    },
    confirm: {
      deleteTitle: "Confirm deletion?",
      deleteMessage: "This action cannot be undone.",
      deleteNamedMessage: '"{name}" will be deleted.',
      cancelCartTitle: "Cancel cart?",
      cancelCartMessage: "Selected items and the pending booking will be lost.",
      clearCartTitle: "Clear cart?",
      clearCartMessage: "All items will be removed from the cart.",
      removeCartItemTitle: "Remove item?",
      removeCartItemMessage: '"{name}" will be removed from the cart.',
      cancelReservationTitle: "Cancel booking?",
      cancelReservationMessage: "The booking will be cancelled. This action cannot be undone.",
      closeMaintenanceTitle: "Close maintenance?",
      closeMaintenanceMessage: "The unit will become available in inventory again.",
      pickupTitle: "Confirm delivery",
      pickupMessage: "Confirm that equipment has been handed to the collaborator?",
      returnTitle: "Confirm return",
      returnMessage: "Confirm the return and condition of the returned equipment?",
      submitReservationTitle: "Confirm booking?",
      submitReservationMessage: "Once confirmed, units will be assigned.",
    },
    nav: {
      home: "Home",
      back: "Back",
      backToHome: "Back to home",
      backToBooking: "Back to bookings",
      employeeSection: "Booking navigation",
      adminSection: "Admin navigation",
      quickAccess: "Quick access",
    },
    flow: {
      title: "Booking progress",
      stepType: "Type",
      stepCategory: "Category",
      stepSubCategory: "Subcategory",
      stepProducts: "Products",
      stepCart: "Cart and dates",
      stepConfirm: "Confirmation",
    },
    states: {
      ALL: "All",
      PENDING_CHECKOUT: "Pending checkout",
      BOOKED: "Requested",
      PICKED_UP: "In use",
      RETURNED: "Returned",
      RETURNED_WITH_INCIDENT: "Returned with incident",
      CANCELLED: "Cancelled",
      CANCELLED_ADMIN: "Cancelled (admin)",
      EXPIRED: "Expired",
    },
    unitStates: {
      AVAILABLE: "Available",
      RESERVED: "Reserved",
      IN_USE: "In use",
      IN_MAINTENANCE: "In maintenance",
      LOST: "Lost",
      RETIRED: "Retired",
      DAMAGED: "Damaged",
    },
    units: {
      title: "Units",
      serialNumber: "Serial number",
      state: "State",
      location: "Location",
      history: "History",
      noUnits: "No units registered for this product",
      noHistory: "No state change history",
      placeholder: "No additional information",
    },
    admin: {
      common: {
        resultCount: "No results | 1 result | {count} results",
        searchName: "Search by name",
        save: "Save",
      },
      dashboard: {
        title: "Admin dashboard",
        subtitle: "Monitor daily operations and access center management tools.",
        overview: "Operational overview",
        overviewHint: "Key activity indicators and daily alerts.",
        operations: "Daily operations",
        operationsHint: "Manage reservations, stock and maintenance.",
        control: "Control and analytics",
        controlHint: "Audit trail, metrics and catalog configuration.",
        alert: "Attention",
        pendingPickups: "Pending deliveries",
        pendingReturns: "Pending returns",
        inMaintenance: "In maintenance",
        expiredReservations: "Expired reservations",
        todayReservations: "Today's requests",
        attentionAlerts: "Active alerts",
        sections: "Sections",
        partialError: "Some data could not be loaded. The rest of the dashboard is available.",
        activityTitle: "Activity (last 7 days)",
        maintenanceHint: "Blocked units pending maintenance closure.",
        maintenanceViewAll: "View all maintenances",
        alertList: {
          title: "Attention centre",
          hint: "Reservations requiring immediate action: delays, expirations and alerts.",
        },
        quickActions: {
          title: "Quick actions",
          viewAllDeliveries: "View all deliveries",
          viewAllReturns: "View all returns",
        },
        inventoryRisk: {
          section: "Critical stock",
          title: "Products with low or no availability",
          hint: "Products with 0 available units or less than 25% of their stock free.",
          empty: "No products with critical stock",
          product: "Product",
        },
      },
      reservations: {
        title: "Reservations management",
        description: "Verify deliveries and returns. Find bookings by collaborator or reference.",
        empty: "No reservations to display",
        emptyHint: "Try another search or switch tab.",
        emptyDeliveries: "No pending deliveries",
        emptyReturns: "No pending returns",
        emptyAttention: "No operational alerts",
        searchLabel: "Find reservation",
        searchPlaceholder: "Collaborator, reference or center…",
        refresh: "Refresh",
        viewDetail: "View detail",
        confirmDeliveryPrompt: "Confirm that equipment has been handed to the collaborator?",
        tabsLabel: "Operational queues",
        tabs: {
          deliveries: "Deliveries",
          returns: "Returns",
          attention: "Attention",
          all: "All",
        },
        queues: {
          deliveries: "Pending deliveries",
          returns: "Pending returns",
          delays: "Delays",
          expiringSoon: "Expiring soon",
          deliveriesTitle: "Delivery queue",
          returnsTitle: "Return queue",
          deliveriesHint: "Requested bookings waiting for physical equipment handover.",
          returnsHint: "Equipment in use waiting for return receipt and verification.",
        },
        attention: {
          title: "Needs attention",
          subtitle: "Delays, overdue returns or bookings about to expire. Contact the responsible collaborator.",
          viewAll: "View all",
          overdueReturn: "Overdue return — contact collaborator",
          returnToday: "Return expected today",
          returnTomorrow: "Return expected tomorrow",
          deliveryOverdue: "Delayed delivery — loan start date has passed",
          deliveryToday: "Delivery expected today",
          deliveryTomorrow: "Delivery expected tomorrow",
          cartExpiringSoon: "Cart about to expire",
          cartExpired: "Expired cart or unfinished booking",
        },
      },
      inventory: {
        title: "Inventory",
        totalUnits: "Total units",
        availableUnits: "Available",
        reservedUnits: "Reserved",
        maintenanceUnits: "In maintenance",
        description: "View product and unit stock",
        total: "Total",
        available: "Available",
        stockLevel: "Stock level",
        stockSummary: "{available} / {total} available",
        stockBarLabel: "Available stock {available} of {total}",
        inUseOrUnavailable: "Unavailable",
        addProduct: "New product",
        autoMaintenanceOnReturn: "Automatically send to maintenance on return",
      },
      units: {
        title: "Units",
        serialNumber: "Serial number",
        state: "State",
        location: "Location",
        tableAriaLabel: "Product units",
        sendToMaintenance: "Send to maintenance",
        sendToMaintenanceTitle: "Send to maintenance?",
        sendToMaintenanceDescription: "Confirm unit {unit} will be sent to maintenance?",
        sendToMaintenanceReason: "Moved manually from inventory because it is damaged",
        sendToMaintenanceSuccess: "Unit sent to maintenance",
        sendToMaintenanceError: "Error sending unit to maintenance",
        history: "History",
        noUnits: "No units registered for this product",
        noHistory: "No state change history",
        placeholder: "No additional information",
      },
      maintenance: {
        title: "Maintenance",
        open: "Open maintenance",
        close: "Close maintenance",
        noMaintenance: "No active maintenance",
        description: "Manage units under maintenance",
      },
      audit: {
        title: "Audit",
        noEvents: "No audit events",
        detail: "Event detail",
        description: "Review booking module activity history",
        filtersTitle: "Filter events",
        filtersSubtitle: "Narrow by period or event type to review traceability",
        eventTypePlaceholder: "Event type (e.g. PICKED_UP)",
        quickFilters: "Quick filters",
        chips: {
          all: "All",
          reservations: "Reservations",
          pickups: "Deliveries",
          returns: "Returns",
          cancelled: "Cancellations",
        },
        fields: {
          aggregate: "Aggregate",
          correlation: "Correlation",
          payload: "Event data",
        },
      },
      analytics: {
        title: "Analytics",
        reservations: "Reservations",
        utilization: "Utilization",
        description: "Booking module metrics and trends",
        noData: "No data for the selected period",
        confirmed: "Requests registered",
        filtersTitle: "Analysis period",
        filtersSubtitle: "Select a date range or use a quick preset",
        periodSummary: "Showing metrics from {from} to {to}",
        dailyBreakdown: "Daily breakdown",
        dailyBreakdownHint: "Requests, deliveries and returns per day",
        presets: {
          last7: "Last 7 days",
          last30: "Last 30 days",
          last90: "Last 90 days",
        },
        charts: {
          dailyTrend: "Daily activity",
          dailyTrendHint: "Day-by-day comparison of requests, deliveries, returns and cancellations",
          periodMix: "Period distribution",
          periodMixHint: "Relative share of each operation type in the filtered range",
          confirmed: "Requests",
          total: "Total",
          noActivity: "No activity recorded in this period",
        },
      },
      catalog: {
        title: "Catalog",
        description: "Manage types, categories, subcategories and products",
        filtersTitle: "Catalog filters",
        filtersSubtitle: "Select the level and search by name to find items quickly",
        tableTypes: "Booking types",
        tableCategories: "Categories",
        tableSubCategories: "Subcategories",
        addType: "New type",
        addCategory: "New category",
        addSubCategory: "New subcategory",
        selectType: "Select a type",
        selectCategory: "Select a category",
        status: "Status",
        enabled: "Enabled",
        disabled: "Disabled",
        confirmDelete: "Confirm deletion?",
      },
      actions: {
        managementTitle: "Equipment verification",
        pickup: "Confirm delivery",
        pickupHint: "Verify that equipment has been handed to the collaborator before confirming.",
        return: "Confirm return receipt",
        returnHint: "Verify the condition of equipment returned at the end of the loan.",
        noActionHint: "No pending actions for this status.",
        cancel: "Cancel reservation",
        createType: "Create type",
        editType: "Edit type",
        createProduct: "Create product",
        editProduct: "Edit product",
        addUnit: "Add unit",
        changeState: "Change state",
        returnCondition: "Returned equipment condition",
        conditionGood: "Good",
        conditionDamaged: "Damaged",
        conditionLost: "Lost",
        incidentNotes: "Incident notes",
        deliveryConfirmed: "Delivery confirmed",
        returnConfirmed: "Return receipt confirmed",
      },
      reservationDetail: {
        timeline: "Timeline",
        requestedAt: "Request registered",
        deliveredAt: "Delivery confirmed",
        returnedAt: "Return receipt confirmed",
      },
    },
    filters: {
      state: "State",
      searchPlaceholder: "Search...",
      clear: "Clear",
      fromDate: "From",
      toDate: "To",
    },
    reservation: {
      collaborator: "Collaborator",
      dates: "Dates",
      state: "State",
      items: "Products",
      center: "Center",
      dateRangeCalendar: {
        ariaLabel: "Booking calendar for {range}",
        legendRange: "Loan period",
        legendPickup: "Pickup",
        legendReturn: "Return",
        selectedDay: "Pickup and return: {date}",
        startDay: "Pickup: {date}",
        endDay: "Return: {date}",
        inRangeDay: "Loan day: {date}",
      },
    },
    items: "products",
    detail: {
      cancel: "Cancel booking",
    },
    errors: {
      BOOKING_RESERVATION_EXPIRED: "Reservation has expired",
      BOOKING_INSUFFICIENT_AVAILABILITY: "Insufficient availability",
      BOOKING_INVALID_DATE_RANGE: "Invalid date range",
      BOOKING_FORBIDDEN_CENTER: "You do not have access to this center",
      BOOKING_INVALID_STATE: "Invalid reservation state",
      loadFailed: "Error loading data",
    },
  },

  common: {
    view: "View",
    confirm: "Confirm",
    cancel: "Cancel",
    apply: "Apply",
    date: "Date",
    search: "Search",
    type: "Type",
    actor: "Actor",
    close: "Close",
    name: "Name",
    description: "Description",
    save: "Save",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    notes: "Notes",
  },

  pagination: {
    prev: "Previous",
    next: "Next",
  },

  identify_collaborator: "Identify collaborator",
  identify_collaborator_description: "Enter the collaborator LDAP UID (e.g. ASANCHE01)",
  search_collaborator: "Search",
  search_collaborator_placeholder: "LDAP UID (e.g. ASANCHE01)",
  delays_data: "Delay data",
  delay_invalid_uid_title: "Invalid UID",
  delay_invalid_uid_description: "Enter an alphanumeric UID (e.g. ASANCHE01)",
  delay_lookup_confirm_title: "Confirm collaborator details",
  delay_lookup_confirm_description: "Verify identity before registering the delay",
  delay_lookup_uid_label: "UID",
  delay_lookup_name_label: "Name",
  delay_lookup_email_label: "Email",
  delay_lookup_job_label: "Job title",
  delay_confirm_and_create: "Confirm and create delay",
  delay_lookup_search_again: "Search another collaborator",
  delay_lookup_not_found: "No collaborator found with that UID",
  delay_lookup_not_found_detail: "No results for {uid} in the people directory",
  delay_lookup_error: "Could not look up the collaborator. Please try again",
  delay_confirm_identity: "Are you {name}?",
  delay_confirm_yes: "Yes, that's me",
  delay_confirm_no: "No, search again",
  delay_justification: "Delay justification",
  delay_justification_text: "Complete delay information before signing",
  delay_category_label: "Reason",
  delay_reason_label: "Reason",
  delay_reason_description_placeholder: "Describe the reason for the delay (optional)",
  delay_preview_draft: "Preview (draft)",
  delay_sign_success: "Delay signed successfully",
  delay_sign_error: "Failed to sign the delay. Please try again",
  justify_delay: "Justify delay",
  delay_duration: "Delay duration",
  delay_table_name: "Name",
  delay_table_email: "Email",
  delay_table_date: "Date",
  delay_table_scheduled_start: "Scheduled start",
  delay_table_arrival_time: "Arrival time",
  delay_table_difference: "Difference (min)",
  delay_table_state: "State",
  delay_table_process: "Process",
  delay_action_download_pdf: "Download PDF",
  delay_action_resume: "Resume process",
  delay_arrival_save_success: "Arrival time updated successfully",
  delay_arrival_save_error: "Could not update arrival time",
  delay_arrival_invalid_time: "Arrival time is invalid",
  delay_arrival_before_scheduled: "Arrival time cannot be earlier than scheduled start",
  scheduledStart: "Scheduled start",
  actual_clock_in: "Arrival time",
  late: "Late",
  on_time: "On time",
  pending: "Pending",
  review_sign_documentation: "Review and sign documentation",
  review_sign_description: "Review the document and sign digitally",
  document_preview: "Document preview",
  view_fullscreen: "Fullscreen",
  justification_form: "Delay justification",
  digital_sign: "Digital signature",
  clear_signature: "Clear signature",
  sign_here_placeholder: "Sign here",
  cancel_and_edit: "Cancel and edit",
  sign_and_submit: "Sign and submit",
  pdf_title: "Clock-in and Delay Details",
  pdf_registry_id: "RECORD ID:",
  pdf_generation_date: "GENERATION DATE:",
  pdf_employee_data: "Employee Data",
  pdf_employee_name: "NAME",
  pdf_employee_email: "EMAIL",
  pdf_delay_details: "Delay Details",
  pdf_scheduled_date: "SCHEDULED DATE",
  pdf_scheduled_time: "SCHEDULED TIME",
  pdf_actual_time: "ACTUAL ARRIVAL TIME",
  pdf_delay_minutes: "DELAY MINUTES",
  pdf_current_state: "CURRENT STATUS",
  pdf_justification: "Justification",
  pdf_category: "CATEGORY",
  pdf_description: "DESCRIPTION",
  pdf_signature: "Employee Signature",
  pdf_footer: "Decathlon Spain - Confidential Document",
  delay_uuid: "Delay UUID",
  boss: "Manager",
  delay_data: "Delay data",
  delays_details: "Delay details",
  delays_sign: "Sign delay",
  analytics_total_late: "Total late arrivals",
  analytics_avg_delay: "Average delay (min)",
  analytics_resolution_rate: "Resolution rate (%)",
  analytics_export: "Export Excel",
  delay_uid_filter: "Collaborator UID",
  delay_uid_filter_placeholder: "Enter UIDs separated by comma",
  delay_uid_filter_search: "Search",

  delayCenters: "Delay Centers",
  reasonCategories: "Delay Reasons",

  delay_center_form: {
    name_placeholder: "Center Name",
    center_code_placeholder: "Center Code",
  },

  reason_category_form: {
    name_placeholder: "Category Name",
    description_placeholder: "Category Description",
  },

  no_role_title: "No access",
  no_role_description: "Your account has no assigned role. Please contact your administrator to request access.",
  no_role_contact: "Contact support",
  visitors_data_integrity_conflict: "Can not create or update visitor due to data integrity violation.",
  visitors_internal_error: "An internal error has occurred.",
  visitors_duplicate_badge: "Badge already in use",

  language: "Language",

  field_obligatory: "This field is required.",
  field_invalid_email: "Enter a valid email (name@domain.com).",
  field_invalid_phone: "Enter a valid phone number.",
  field_invalid_dni: "Enter a valid Identification number.",
  select_reason_delay: "Select a reason for the delay.",
  delay_reason_description_label: "Reason description",
  job_name: "Job name",
  text: "Text",
  select_search: "Select",
  checkbox: "Checkbox",
  minute: "minute",
  minutes: "minutes",
  saving: "Saving...",
  save_changes: "Save changes",
  hours_team: "team hours",
  diff: "difference",
  users: "users",
  team_that_you_search: "team you are searching",
  username_that_you_search: "profile you are searching",
  personal_data: "personal data",
  last_name: "last name",
  center_data: "center data",
  complementary_data: "complementary data",
  your_dni: "your dni",
  Auditors: "Auditors",
  results: "Results",
  previous: "Previous",
  next: "Next",
  showing: "Showing",
  of: "of",
  visitors_data: "Data",
  form: "Form",
  actions: "Actions",
  delete_reason_category_description: "You are about to delete a delay reason",
  deleted_reason_category: "Delay reason deleted",
  more: "More",
  collaborators: "collaborators",
  normal: "Normal",
  phone: "Phone",
  delays: "Delays",
  booking_type: "Booking type",
  booking_category: "Category",
  booking_subcategory: "Subcategory",
  bookingTypes: "Type",
  bookingCenters: "Centers",
  bookingCategories: "Categories",
  bookingSubcategories: "Subcategories",
  select_booking_type: "Select a type",
  select_booking_center: "Select a center",
  select_booking_category: "Select a category",
  select_booking_subcategory: "Select a subcategory",
  remove_delete_success: "Delay removed successfully",
  remove_delete_error: "Could not remove delay. Please try again",
  remove_delay_description: "You are about to delete a delay",
  booking_center: "Center",
  visitors_number: "Number of visitors",
  export_to_excel: "Export",
};

export default message;
